import React, { FC } from 'react';
import { Spinner } from '@quantum/ui-atoms';
import * as styles from './styles.module.scss';

export interface LoadingProps {
  title: string;
  description: string;
  disableText?: boolean;
}

export const Loading: FC<LoadingProps> = ({ title, description, disableText = false }) => (
  <div className={styles.spinnerPage}>
    <Spinner />
    {!disableText && (
      <>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </>
    )}
  </div>
);
